import { ReactNode } from 'react';
import { Link } from '@mui/material';

import { LinkButtonSt } from './account-links.styled';

interface IProps {
  children: ReactNode;
  href: string;
}

export const LinkButton = ({ href, children }: IProps) =>
<LinkButtonSt id="link-button-component__components-account-links__linkbuttonst__l12"
sx={{ p: '5px' }}
LinkComponent={Link}
href={href}
target="_blank"
rel="noopener noreferrer">
  
    {children}
  </LinkButtonSt>;